import services from 'services/module';
import {tagsInput} from 'lazy_modules';
import {HttpSvcFactory} from "./HttpSvc";

export class TagsSvc {
    tagsLibLoaded: boolean;
    tagsCache: anm.Tag[] = [];
    restTags = this.HttpSvc<anm.Tag[]>('tags');

    constructor(private $ocLazyLoad: oc.ILazyLoad,
                private $q: ng.IQService,
                private HttpSvc: HttpSvcFactory) {

        tagsInput().then(m => $ocLazyLoad.load(m)).then(() => this.tagsLibLoaded = true);
    }

    loadTags = (query: string) =>  this.$q(resolve => {
        if (this.tagsCache.length === 0) {
            this.restTags.get({params: {all: this.canCreateSuper()}}).then(response => {
                this.tagsCache = this.mapTagsCache(response.data);
                resolve(this.fuzzySearch(query));
            });
        } else {
            resolve(this.fuzzySearch(query));
        }
    });

    saveTag = (tag: anm.Tag, projectId: string) => this.restTags.securePost({projectId, tag})
        .then(() => this.tagsCache.push(tag));

    tagAdded = (tag: anm.Tag, projectId: string) => this.saveTag(tag, projectId);

    tagRemoved = (tag: anm.Tag, projectId: string) => this.restTags.chain('delete').securePost({projectId, tag});

    private fuzzySearch = (query: string) =>
        _.filter(this.tagsCache, tag => {
            let j = 0;
            for (let i = 0; i < query.length; i++) {
                const l = query[i];
                if (l === ' ') continue;

                j = tag.name.indexOf(l, j);
                if (j === -1) return false;
            }
            return true;
        });

    private mapTagsCache = (data: Array<anm.Tag>) => {
        if (this.canCreateSuper()) {
            data = data.map(tag => {
                if (tag.type === 'SUPER') {
                    tag.name = '!' + tag.name;
                }
                return tag;
            });
        }
        return data;
    };

    private canCreateSuper = () => {
        const { Admin } = options.user.subscriptionDetails.studio.features;
        return Admin && Admin.canCreateSuperTags || null;
    }
}

services.service('TagsSvc', TagsSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/TagsSvc.ts